import {Component} from "react";
import md_logo from "../../../assets/img/logos/md-logo.png";
import signUp_bg from "../../../assets/img/registration/webSignUp.png";
import React from "react";
import * as routeConstants from "../../../const/route/Route";
import './style.scss';
import * as actionCreator from "../../../store/Action";
import {connect} from "react-redux";
import {Col, Row, Button} from "reactstrap";
import IntlTelInput from "react-intl-tel-input";
import {Icon, Input} from "semantic-ui-react";
import SocialLogins from './SocialMediaBtn/SocialMediaBtn'
import ImgBg from './SideBgImg/index'
import * as util from "../../../util/Validator";
import * as common from "../../../const/Common/CommonFunc";
import axiosAuth from "../../../axios/axios_authorization";
import Cookies from "js-cookie";
import apiConfig from "../../../axios/axios_api_services";
import * as qs from "qs";
import {MDBModal, MDBModalBody} from "mdbreact";
import verified_img from "../../../assets/img/registration/verified.png";
import * as keys from '../../../const/key/Key'
import JWT_Decode from "jwt-decode";

class App extends Component {


  state={
    validMobile: false,
    mobile:'',
    mobile_:'',
    password:'',
    isModal:false,
    isSuccess:false
  }
  componentDidMount() {
    let eventId = new URLSearchParams(window.location.search).get('e');
    if (eventId) {
      sessionStorage.setItem(keys.SUB_EVENT_QR_UUID,eventId);
      let token = Cookies.get("68a6102f6ed24899420170004a0273b8");
      if (token !== undefined) {
        let decode_token = JWT_Decode(token);
        let USER_AUTHORITIES = decode_token && decode_token.authorities && decode_token.authorities.length > 0 ? decode_token.authorities[0] : null;
        if (USER_AUTHORITIES === 'ROLE_MOBILE_USER') this.props.history.push("/public/user-details");
      }
    }else{
      sessionStorage.removeItem(keys.SUB_EVENT_QR_UUID);
    }
  }
  viewPassword = () => {
    let i = document.getElementById("password-field");
    if (i.type === "password") {
      i.type = "text"
    } else {
      i.type = "password"
    }
  };

  onChangeText = (e) => {
    this.setState({
      password: e.target.value
    })
  }

  onHandleMobile = (condition, value, object, withdialcod) => {
    value = value.startsWith("00") ? "+" + value.substr(2) : value;
    condition = util.customMobileValidation(withdialcod.substr(1).replace(/\s/g, ""),condition);
    this.setState({
      validMobile:condition,
      mobile:value,
      mobile_: withdialcod.substr(1).replace(/\s/g, "")
    });
  };

  verifyOtp = () => {
    this.setState({isModal:!this.state.isModal})
  }


  validateSignIn = () => {
    !this.state.validMobile ? common.notifyMessage("Please enter valid mobile no") :
      this.state.password.trim() === '' ? common.notifyMessage("Please enter the password") :
        this.signInAction()
  }

  signInAction = () => {
    this.props.spinnerHandler(true);

    const headers = {
      "Content-Type": "application/x-www-form-urlencoded"
    };

    const formData = new FormData()
    formData.append("username", this.state.mobile_)
    formData.append("password", this.state.password)
    formData.append("grant_type", 'password')

    axiosAuth.post(apiConfig.OAUTH, formData,{auth:{username:'PUBLIC_CLIENT_ID',password:''}}, {headers: headers})
      .then(response => {
        if (response.status === 200) {
          this.props.spinnerHandler(false);
          Cookies.set('68a6102f6ed24899420170004a0273b8', response.data.access_token);
          Cookies.set('9b8558ba3f051677daf36ebfc67f29fa', response.data.refresh_token);
          this.props.history.push("/public/user-details");
        }
      })
      .catch(error => {
        this.props.spinnerHandler(false);
        common.notifyMessage("You've entered an incorrect username/password combination");
      })
  }

  socialLoginHandler = (obj) => {
    this.props.spinnerHandler(true);

    const headers = {
      "Content-Type": "application/x-www-form-urlencoded",
      "Authorization": "Basic UFVCTElDX1NPQ0lBTF9DTElFTlRfSUQ6",
      "Username": "PUBLIC_SOCIAL_CLIENT_ID",
      "Password": ""
    }

    const userObj = {
      username: obj.userSocialId + " " + obj.socialMediaToken,
      password: obj.userSocialId,
      grant_type: "password"
    }

    axiosAuth.post(apiConfig.OAUTH,qs.stringify(userObj),{headers:headers})
      .then(response => {
        if (response.status === 200) {
          this.props.spinnerHandler(false);
          Cookies.set('68a6102f6ed24899420170004a0273b8', response.data.access_token);
          Cookies.set('9b8558ba3f051677daf36ebfc67f29fa', response.data.refresh_token);
          this.props.history.push("/public/user-details");
        }
      })
      .catch(error => {
        this.props.spinnerHandler(false);
        common.warningAlert("You've not registered yet.");
      })
  }


  render() {
    let {isModal, isSuccess} = this.state;
    return (
      <Row style={{background:'white'}}>
        <ImgBg pgType='signIn'/>
        <Col className='signIn-div'>
          <img src={md_logo} alt={"."} id={'md_logo'}/>
          <div>
            {/*<Lbl>Mobile</Lbl>*/}
            <IntlTelInput
              style={{width: '100%', marginBottom:'15px'}}
              type={"text"}
              fieldName={"Mobile Number"}
              value={this.state.mobile}
              containerClassName="intl-tel-input dashboard-intl"
              inputClassName="form-control"
              onPhoneNumberChange={this.onHandleMobile}
              required={true}
              preferredCountries={['lk']}
              defaultCountry={"lk"}
              nationalMode={false}
              icon='mobile alternate'
              placeholder="Mobile"
            />
          </div>
          <div>
            {/*<Lbl>Password</Lbl>*/}
            <Input id={"password-field"} type={"password"}
              onChange={this.onChangeText}
              value={this.state.password}
                   style={{width: '100%', marginBottom:'15px'}}
                   icon={<Icon onMouseUp={() => this.viewPassword(false)}
                               onMouseDown={() => this.viewPassword(true)} name='eye' link/>}
                   placeholder='Password'/>
          </div>
          <Button className={'done-btn'} color='warning' onClick={() => this.validateSignIn()}> Sign in</Button>
          <SocialLogins type={'sign-in'} setData={this.socialLoginHandler}/>
          <div className={'sign-up-link'}>
            <p>Don’t have an account?
              <span onClick={() => this.props.history.push(routeConstants.PUBLIC_WEB_SIGN_UP_PAGE)}> Sign up</span>
            </p>
          </div>
          {/*{
            isModal &&
            <MDBModal isOpen={isModal}  toggle={() => this.verifyOtp()}>
              <MDBModalBody >
                <div>
                  {isSuccess ? <img src={verified_img} width='auto' height='42px'/> : <br/>}
                  <p className={'title'}>{isSuccess ? 'Verified!' : 'Not Verified!'}</p>
                  <p style={{margin:0}}>{isSuccess ? 'You have successfully verified the account.' : 'Invalid login credentials'}</p>
                  <Button className={'done-btn'} onClick={() => this.verifyOtp()}>{isSuccess ? `Let's Start` : 'Try Again'}</Button>
                </div>
              </MDBModalBody>
            </MDBModal>
          }*/}
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => {
  return {
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
   };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
